// @ts-ignore
const userLanguage = window.appSetup?.localization?.language || 'en';
// @ts-ignore
const navigationUrlList = window.appSetup?.links?.navigation;

// pages which need a redirect for translated url path, e.g. for supporting email links
const translatedRoutes =
  !navigationUrlList || userLanguage === 'en'
    ? [
        // dirty fix for the case when switching language by parameter from de to en on SEA LPs "registrierung" + language = 'en'
        // set language url parameter overrides appSetup
        {
          path: navigationUrlList.registration,
          redirect: { name: 'registration' },
        },
      ]
    : [
        // my-jobleads redirect to dashboard
        {
          path: navigationUrlList.myJobleads,
          redirect: (to) => ({
            ...to,
            name: 'my-jobleads',
          }),
        },

        // modals pages
        {
          path: navigationUrlList.registration,
          redirect: { name: 'registration' },
        },
        {
          path: navigationUrlList.registrationJob,
          redirect: { name: 'registration-job' },
        },
        {
          path: navigationUrlList.notifications,
          redirect: { name: 'email-notifications' },
        },
        {
          path: navigationUrlList.changePassword,
          redirect: (to) => ({
            ...to,
            name: 'change-password',
          }),
        },
        {
          path: navigationUrlList.resetPassword,
          redirect: { name: 'forgot-password' },
        },

        // footer pages
        {
          path: navigationUrlList.imprint,
          redirect: { name: 'site-notice' },
        },
        {
          path: navigationUrlList.privacy,
          redirect: { name: 'privacy-policy' },
        },
        {
          path: navigationUrlList.terms,
          redirect: { name: 'terms-of-use' },
        },
        {
          path: navigationUrlList.contact,
          redirect: { name: 'contact' },
        },
      ];

export default translatedRoutes;
